/* Homepage review strip — fetches approved reviews (all products) and shows the
   most recent ones that have a photo. Silent if the endpoint is unset or empty. */

(function () {
  'use strict';

  var root = document.querySelector('[data-home-reviews]');
  if (!root) return;

  var endpoint = root.dataset.endpoint || '';
  var limit = parseInt(root.dataset.limit, 10) || 6;
  var list = root.querySelector('[data-home-reviews-list]');
  if (!endpoint || !list) return;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function starsHtml(rating) {
    var filled = Math.round(rating);
    var path = '<path d="M12 2l2.9 6.3 6.8.6-5.1 4.5 1.5 6.7L12 17.8 5.9 20.6l1.5-6.7L2.3 8.9l6.8-.6z"/>';
    var out = '<span class="stars" role="img" aria-label="' + rating + ' out of 5">';
    for (var i = 1; i <= 5; i++) {
      out += '<svg class="' + (i <= filled ? 'star-on' : 'star-off') +
             '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' + path + '</svg>';
    }
    return out + '</span>';
  }

  fetch(endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'featured=1')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var reviews = (data.reviews || data || []).filter(function (r) { return r.photo; });
      if (!reviews.length) return;

      reviews = reviews.slice(0, limit);
      list.innerHTML = reviews.map(function (r) {
        return '<article class="rev">' +
          '<div class="rev__photo"><img src="' + esc(r.photo) + '" alt="Review photo from ' + esc(r.name) + '" loading="lazy"></div>' +
          '<div class="rev__top">' + starsHtml(r.rating) + '</div>' +
          '<p class="rev__body">' + esc((r.body || '').slice(0, 140)) + '</p>' +
          '<div class="rev__by"><span class="rev__name">' + esc(r.name) + '</span></div>' +
        '</article>';
      }).join('');

      root.hidden = false;
    })
    .catch(function () { /* stay hidden */ });
})();
